export const formatCurrency = (num: number | string): string => Number(num).toLocaleString('en-US', {
  style: 'currency',
  currency: 'USD',
});

export default formatCurrency;
